import React from 'react'
import { Divider, Tag } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCodeBranch } from '@fortawesome/free-solid-svg-icons'
import packageJson from '../../../package.json'
import { IPackageJson, Version } from '@nic/ui-comps'

type Environment = 'devel' | 'production' | 'pubtest' | 'local' | 'cypress';

const ENV_COLORS: Record<Environment, string> = {
  devel: 'green',
  production: '',
  pubtest: 'volcano',
  local: 'blue',
  cypress: 'purple',
}

interface EnvironmentTagProps {
  env: Environment;
}

const EnvironmentTag: React.FC<EnvironmentTagProps> = ({ env }) => {
  if (!env || env === 'production') return null // Nessun tag in produzione

  return (
    <Tag
      color={ENV_COLORS[env]}
      style={{ fontWeight: 'bold', borderRadius: '8px', padding: '2px 15px', fontSize: '1rem' }}
    >
      <FontAwesomeIcon icon={faCodeBranch as IconProp} /> <span style={{padding:2, color: 'lightgray'}}></span> {env.toUpperCase()} <Divider type={'vertical'} />
      <Version packageJson={packageJson as IPackageJson} style={{ fontSize: '.9rem' }} />
    </Tag>
  )
}


export default EnvironmentTag
